function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { GridItem, TextField } from 'seagull';
import { useOnMount } from "../../hooks/useOnMount";
import { agreementNameValidation } from "../../utils/react-hook-form.utils";
export function AgreementName(_ref) {
  let {
    agreementTitle,
    showWarning,
    setAgreementTitle,
    setAgreementTitleValid,
    label
  } = _ref;
  const {
    control,
    formState,
    watch,
    trigger
  } = useForm({
    mode: 'all',
    defaultValues: {
      agreementTitle
    }
  });
  useEffect(() => {
    return watch(data => {
      var _data$agreementTitle;
      setAgreementTitle((_data$agreementTitle = data.agreementTitle) !== null && _data$agreementTitle !== void 0 ? _data$agreementTitle : '');
    }).unsubscribe;
  }, [setAgreementTitle, watch]);
  useEffect(() => {
    setAgreementTitleValid(formState.isValid);
  }, [formState, setAgreementTitleValid]);
  useEffect(() => {
    if (showWarning) trigger('agreementTitle');
  }, [showWarning, trigger]);
  useOnMount(() => {
    trigger('agreementTitle');
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GridItem, {
    span: 9
  }, /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "agreementTitle",
    rules: agreementNameValidation,
    render: _ref2 => {
      let {
        field,
        fieldState: {
          isTouched,
          error
        }
      } = _ref2;
      return /*#__PURE__*/React.createElement(TextField, _extends({}, field, agreementNameValidation.dataAttr, {
        label: label,
        testid: "agreement-studio-customer-details-input-display-title",
        placeholder: "The agreement name will help you identify this agreement",
        error: (showWarning || isTouched) && !!error,
        helperText: (showWarning || isTouched) && (error === null || error === void 0 ? void 0 : error.message)
      }));
    }
  })), /*#__PURE__*/React.createElement(GridItem, {
    span: 3
  }));
}